import Vuex from 'vuex';
import getters from './getters';
import actions from './actions';
import i18n from './modules/i18n';
import cart from './modules/cart';
import request from './modules/request';
import layer from './modules/layer';
import wishlist from './modules/wishlist';
import sharedEnv from './modules/sharedEnv';
import user from './modules/user';
import script from './modules/script';
import searchEngine from './modules/searchEngine';
export default (function () {
  return new Vuex.Store({
    actions: actions,
    getters: getters,
    modules: {
      i18n: i18n,
      cart: cart,
      request: request,
      layer: layer,
      wishlist: wishlist,
      sharedEnv: sharedEnv,
      user: user,
      script: script,
      searchEngine: searchEngine
    }
  });
});